export default __webpack_public_path__ + "static/3_showman-flex-69fd9ba515f91fa1e2842e4b7d2bf20e.png";